"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _price = require("./price.proptypes");

var _constant = require("./constant");

var _constant2 = require("../constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var PriceContainer = _styledComponents.default.span.withConfig({
  displayName: "Price__PriceContainer",
  componentId: "sc-1xkv6to-0"
})(["display:inline-flex;align-items:baseline;", " ", ""], function (_ref) {
  var marginRight = _ref.marginRight;
  return marginRight && "margin-right: ".concat(marginRight, ";");
}, function (_ref2) {
  var theme = _ref2.theme,
      strikethrough = _ref2.strikethrough,
      color = _ref2.color;
  return strikethrough && "\n      text-decoration: line-through;\n      color: ".concat(theme.colors[color], ";\n  ");
});

var roundToTwo = function roundToTwo(num) {
  return +"".concat(Math.round("".concat(num, "e+2")), "e-2");
};

var currencyFormat = function currencyFormat(amount, decimalType) {
  var onlyPrice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var priceInNumber = amount * 1; // conver string to number

  var price = priceInNumber;

  switch (decimalType) {
    case _constant.DECIMAL_TYPE.FLOAT:
      price = priceInNumber.toFixed(2);
      break;

    case _constant.DECIMAL_TYPE.ROUND:
      price = Math.round(priceInNumber);
      break;

    case _constant.DECIMAL_TYPE.FLOOR:
      price = Math.floor(priceInNumber);
      break;

    case _constant.DECIMAL_TYPE.CEIL:
      price = Math.ceil(priceInNumber);
      break;

    default:
      price = Number(amount);
      price = roundToTwo(price);
  }

  return onlyPrice ? price : price && price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

var localeCurrencyFormat = function localeCurrencyFormat(currencyCode, amount, display, locale) {
  var noDecimalValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var decimalType = arguments.length > 5 ? arguments[5] : undefined;
  var hideCurrency = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    var formatter = ''; // let temp = noDecimalValues;
    // if (DECIMALTYPES.includes(decimalType)) {
    //   temp = true;
    // }

    var selectedLocale = '';

    if (!hideCurrency) {
      selectedLocale = currencyCode === 'IDR' ? 'id-id' : locale;
    }

    var format = {};
    format.currency = currencyCode || 'USD';

    if (hideCurrency === false) {
      format.style = 'currency';
      format.currencyDisplay = display;
    }

    if (noDecimalValues) {
      format.maximumFractionDigits = 0;
      format.minimumFractionDigits = 0;
    }

    try {
      formatter = new Intl.NumberFormat(selectedLocale || navigator.userLanguage || navigator.language, format);
    } catch (_unused) {
      formatter = new Intl.NumberFormat(navigator.userLanguage || navigator.language || _constant.DEFAULT_LOCALE, {
        style: 'currency',
        currency: currencyCode || 'USD',
        currencyDisplay: display
      });
    }

    return formatter.format(amount);
  }

  return '';
};

var Price = function Price(props) {
  var amount = props.amount,
      currency = props.currency,
      locale = props.locale,
      allowLocaleFormat = props.allowLocaleFormat,
      currencyDisplay = props.currencyDisplay,
      hideCurrency = props.hideCurrency,
      theme = props.theme,
      customProperties = props.customProperties,
      accessible = props.accessible,
      decimalType = props.decimalType,
      color = props.color,
      priceTemplate = props.priceTemplate,
      pricePrefix = props.pricePrefix,
      strikethrough = props.strikethrough,
      viewport = props.viewport,
      customFontSize = props.customFontSize,
      customCurrencySize = props.customCurrencySize,
      noDecimalValues = props.noDecimalValues;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var currencyText = currency ? currency.toUpperCase() : '';

  var getPriceTemplate = function getPriceTemplate(template) {
    var templateProps = {
      currencyText: currencyText,
      amount: amount,
      decimalType: decimalType,
      color: color,
      locale: locale,
      allowLocaleFormat: allowLocaleFormat,
      currencyDisplay: currencyDisplay,
      viewport: viewport,
      customFontSize: customFontSize,
      customCurrencySize: customCurrencySize,
      noDecimalValues: noDecimalValues,
      hideCurrency: hideCurrency
    };

    switch (template) {
      case _constant.PRICE_TEMPLATE.TEMPLATE2:
        {
          return /*#__PURE__*/_react.default.createElement(AddonsPriceTemplate, templateProps);
        }

      case _constant.PRICE_TEMPLATE.TEMPLATE3:
        {
          return /*#__PURE__*/_react.default.createElement(FareBreakdownPriceTemplate, templateProps);
        }

      default:
        {
          return /*#__PURE__*/_react.default.createElement(DefaultPriceTemplate, templateProps);
        }
    }
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PriceContainer, (0, _extends2.default)({
      tabIndex: tabIndex,
      strikethrough: strikethrough,
      color: color,
      theme: themeContext
    }, customProperties), /*#__PURE__*/_react.default.createElement(PricePrefix, {
      pricePrefix: pricePrefix,
      color: color,
      viewport: viewport
    }), getPriceTemplate(priceTemplate));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

var isCurrencyAmount = function isCurrencyAmount(currencyData) {
  var numString = currencyData.split(/[.,]/).join('');
  return !Number.isNaN(parseInt(numString, 10));
};

var isCurrencyText = function isCurrencyText(currencyData) {
  return currencyData.length === 3 && !isCurrencyAmount(currencyData);
};

var renderLocaleCurrency = function renderLocaleCurrency(_ref3) {
  var amount = _ref3.amount,
      decimalType = _ref3.decimalType,
      currencyText = _ref3.currencyText,
      currencyDisplay = _ref3.currencyDisplay,
      locale = _ref3.locale,
      customCurrencySize = _ref3.customCurrencySize,
      customFontSize = _ref3.customFontSize,
      color = _ref3.color,
      noDecimalValues = _ref3.noDecimalValues,
      hideCurrency = _ref3.hideCurrency;
  var currencyFormattedValue = currencyFormat(amount, decimalType, true);
  return localeCurrencyFormat(currencyText, currencyFormattedValue, currencyDisplay, locale, noDecimalValues, decimalType, hideCurrency).split(_constant.NON_BREAKING_SPACE).map(function (currencyData) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      bold: !!isCurrencyText(currencyData),
      type: isCurrencyText(currencyData) ? customFontSize : customCurrencySize,
      accessible: false,
      color: color
    }, currencyData, "\xA0");
  });
};

var AddonsPriceTemplate = function AddonsPriceTemplate(props) {
  var currencyText = props.currencyText,
      amount = props.amount,
      decimalType = props.decimalType,
      color = props.color,
      allowLocaleFormat = props.allowLocaleFormat,
      locale = props.locale,
      currencyDisplay = props.currencyDisplay,
      viewport = props.viewport,
      noDecimalValues = props.noDecimalValues,
      hideCurrency = props.hideCurrency;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideCurrency && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: false,
    color: color,
    bold: true,
    type: viewport === _constant2.DEVICE_TYPE.DESKTOP ? 'titleSmall' : 'default'
  }, allowLocaleFormat ? localeCurrencyFormat(currencyText, amount, currencyDisplay, locale, noDecimalValues, decimalType, hideCurrency) : currencyFormat(amount, decimalType), "\xA0"), !allowLocaleFormat && /*#__PURE__*/_react.default.createElement(_Text.default, {
    bold: viewport === _constant2.DEVICE_TYPE.DESKTOP,
    type: viewport === _constant2.DEVICE_TYPE.DESKTOP ? 'sub' : 'textSmall',
    accessible: false,
    color: color
  }, currencyText));
};

var FareBreakdownPriceTemplate = function FareBreakdownPriceTemplate(props) {
  var currencyText = props.currencyText,
      amount = props.amount,
      decimalType = props.decimalType,
      color = props.color,
      allowLocaleFormat = props.allowLocaleFormat,
      locale = props.locale,
      currencyDisplay = props.currencyDisplay,
      viewport = props.viewport,
      customFontSize = props.customFontSize,
      noDecimalValues = props.noDecimalValues,
      hideCurrency = props.hideCurrency;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideCurrency && !allowLocaleFormat && /*#__PURE__*/_react.default.createElement(_Text.default, {
    bold: viewport === _constant2.DEVICE_TYPE.DESKTOP,
    type: viewport === _constant2.DEVICE_TYPE.DESKTOP && customFontSize ? customFontSize : 'small',
    accessible: false,
    color: color
  }, currencyText, "\xA0"), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: false,
    color: color,
    bold: true,
    type: viewport === _constant2.DEVICE_TYPE.DESKTOP && customFontSize ? customFontSize : 'small'
  }, allowLocaleFormat ? localeCurrencyFormat(currencyText, currencyFormat(amount, decimalType, true), currencyDisplay, locale, noDecimalValues, decimalType, hideCurrency) : currencyFormat(amount, decimalType), "\xA0"));
};

var DefaultPriceTemplate = function DefaultPriceTemplate(props) {
  var color = props.color,
      amount = props.amount,
      decimalType = props.decimalType,
      currencyText = props.currencyText,
      allowLocaleFormat = props.allowLocaleFormat,
      customFontSize = props.customFontSize,
      customCurrencySize = props.customCurrencySize,
      hideCurrency = props.hideCurrency;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !allowLocaleFormat ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideCurrency && /*#__PURE__*/_react.default.createElement(_Text.default, {
    bold: true,
    type: customFontSize,
    accessible: false,
    color: color
  }, currencyText), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: false,
    color: color,
    type: customCurrencySize
  }, "\xA0", currencyFormat(amount, decimalType))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderLocaleCurrency(props)));
};

var PricePrefix = function PricePrefix(props) {
  var pricePrefix = props.pricePrefix,
      color = props.color,
      viewport = props.viewport;
  return pricePrefix ? /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: false,
    color: color,
    type: viewport === _constant2.DEVICE_TYPE.DESKTOP ? 'default' : 'textSmall'
  }, _constant.PRICE_PREFIX[pricePrefix], "\xA0") : null;
};

Price.propTypes = _price.PriceProptypes.PropTypes;
Price.defaultProps = _price.PriceProptypes.DefaultProps;
AddonsPriceTemplate.propTypes = _price.PriceTemplateProptypes.PropTypes;
AddonsPriceTemplate.defaultProps = _price.PriceTemplateProptypes.DefaultProps;
FareBreakdownPriceTemplate.propTypes = _price.PriceTemplateProptypes.PropTypes;
FareBreakdownPriceTemplate.defaultProps = _price.PriceTemplateProptypes.DefaultProps;
DefaultPriceTemplate.propTypes = _price.PriceTemplateProptypes.PropTypes;
DefaultPriceTemplate.defaultProps = _price.PriceTemplateProptypes.DefaultProps;
PricePrefix.propTypes = _price.PricePrefixProptypes.PropTypes;
PricePrefix.defaultProps = _price.PricePrefixProptypes.DefaultProps;
var _default = Price;
exports.default = _default;